import React from 'react';
import '../App.css'; // Assuming App.css has basic modal styles

function ConfirmationDialog({ isOpen, title, message, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="modal-title">{title}</h3>
        <p className="modal-message">{message}</p>
        <div className="modal-actions">
          <button onClick={onConfirm} className="modal-confirm-button">Confirm</button>
          <button onClick={onCancel} className="modal-cancel-button">Cancel</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmationDialog;
